import React from 'react';
import * as PropTypes from 'prop-types';

const SidebarItem = (props) => {
  let background = "";
  if(props.active) background = "#eceeef";
  else background = "transparent";

  let styles = {
    background,
    color: '#888',
    textDecoration: 'none',
    borderRadius: '0',
    fontSize: '12px',
    fontWeight: '450',
    marginBottom: '.1em',
    paddingTop: '1em',
    paddingBottom: '1em',
    borderBottom: "1px solid #eceeef",
    transition: 'background .75s',
    marginRight: 0
  };

  return (
    <button className="btn btn-link nav-link text-left"
            style={styles} onClick={props.toggleActive}>
      {props.text.toUpperCase()}
      </button>
  );
};
SidebarItem.propTypes = {
  text: PropTypes.string,
  active: PropTypes.bool,
  toggleActive: PropTypes.func.isRequired
};

export default SidebarItem;
